<div class="main" *ngIf="columndata">
    <div *ngIf="showLoader" class="loader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="header">
      <div class="text">
        {{ 'ORDER_VIEW.title' | translate}} #{{awb_number}}
      </div>
      <div class="created_at">
        {{ 'ORDER_VIEW.created_date' | translate}} : {{columndata ? columndata.created_at ? toShortDateTime(columndata.created_at):"--" :"--"}}
        <i class="material-icons" (click)="closeModal();">clear</i>
      </div>
    </div>
    <div class="section">
  
      <div class="body">
        <div>
          <div class="body-tabs">
            <mat-grid-list cols="2" rowHeight="2:1">
              <mat-grid-tile [ngClass]="{'selected' : tabIndex==0}" (click)='switchTab(0)'>
                <span>{{'ORDER_VIEW.title' | translate}}</span>
              </mat-grid-tile>
              <mat-grid-tile [ngClass]="{'selected' : tabIndex==1}" (click)='switchTab(1)'>
                <span>{{'ORDER_VIEW.activityTimeline' | translate}}</span>
              </mat-grid-tile>
            </mat-grid-list>
          </div>
        </div>
  
        <div class="body-section" [hidden]="tabIndex!=0">
  
          <div class="top_sec">
            <div class="pick_sec" *ngFor="let pick of pickup; let i=index;">
              <div class="pickup">P{{i+1}}</div>
              <span class="pickup_details">
                <div>
                  <strong class="name">
                    {{(pick.loc_id && pick.loc_id.name) ? pick.loc_id.name : ''}}
                    
                  </strong>
                </div>
                <div>{{ (pick.loc_id && pick.loc_id.city) ? pick.loc_id.city : ''}}</div>
                <div> {{toShortDate(pick.date_time )}}</div>
              </span>
            </div>
            <div class="divider_sec">
              <span class="divider">- - - - - - - - - - - - - - - - - - </span>
              <div class="status">{{awb_status}}</div>
            </div>
            <div class="drop_sec" *ngFor="let del of delivery; let i=index;">
              <span class="drop_new">D{{i+1}}</span>
              <span class="drop_details">
                <div>
                  <strong class="name">
                   
                    {{(del.loc_id && del.loc_id.name) ? del.loc_id.name : ''}}
                  </strong>
                </div>
                <div>{{ (del.loc_id && del.loc_id.city) ? del.loc_id.city : ''}}</div>
                <div>{{ (del.date_time && deliveryEdd) ? toShortDate(del.date_time) : deliveryEdd }}</div>
              </span>
            </div>
          </div>
          <div class="bottom_sec">
            <div class="details">
              <div class="detail">
                <div class="label">
                  {{ 'ORDER_VIEW.customer' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ client }}
                </div>
              </div>
              <div class="detail">
                <div class="label">
                  {{ 'ORDER_VIEW.shipment_weight' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ columndata.weight }}
                </div>
              </div>
              <div class="detail">
                <div class="label">
                  {{ 'ORDER_VIEW.documents' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  <div class="documentSection" *ngIf="documentsArray.length;">
                    <div class="documents" *ngFor="let item of documentsArray">
                      <a href="{{item.link}}" class="icon">
                        <img
                          *ngIf="item.extension == 'png' || item.extension == 'jpg' || item.extension == 'jpeg' || item.extension == 'gif'"
                          class="image" src="assets/image-icon.svg">
                        <img *ngIf="item.extension == 'pdf'" class="image" src="assets/PDF-icon.svg">
                        <img
                          *ngIf="item.extension == 'doc' || item.extension == 'csv' || item.extension == 'docx' || item.extension == 'txt' || item.extension == 'xlsx'"
                          class="image" src="assets/Doc-icon.svg">
                      </a>
                    </div>
                  </div>
                  <div *ngIf="!documentsArray.length;">
                    --
                  </div>
                </div>
              </div>
              <div class="detail">
                <div class="label">
                  {{ 'ORDER_VIEW.AWBNumbers' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value" *ngIf="order_details">
                  {{order_details}}
                </div>
                <div class="value" *ngIf="!order_details">
                  <span>
                    --
                  </span>
                </div>
              </div>
  
              <div class="detail">
                <div class="label">
                  {{ 'ORDER_VIEW.number_of_packages' | translate}}
                  <!-- <div class="sub-title" style="text-align: center;padding-top: 10px;
                      font-weight: bold;"> {{ 'ORDER_VIEW.or' | translate}}</div> -->
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ columndata.no_of_packages || '--' }}
                </div>
              </div>
  
              <div class="detail">
                <div class="label">
                  {{ 'ORDER_VIEW.cbm' | translate}}
                  <div class="sub-title"> ({{ 'ORDER_VIEW.cubic_meter' | translate}})</div>
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ columndata.cbm_value || '--'}}
                </div>
              </div>
              <div class="detail">
                <div class="label">
                  {{ 'ORDER_VIEW.service_provider' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ columndata.service_provider || '--' }}
                </div>
              </div>
              <div class="detail">
                <div class="label">
                  {{ 'ORDER_VIEW.comments' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ columndata.comments || '--' }}
                </div>
              </div>
              <div class="detail" *ngIf="columndata.eway_bill_no">
                <div class="label">
                  {{ 'ORDER_VIEW.eway_bill_no' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ columndata.eway_bill_no || '--' }}
                </div>
              </div>
              <div class="detail" *ngIf="columndata.others && columndata.others.invoice_date">
                <div class="label">
                  {{ 'ORDER_VIEW.invoice_date' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ toShortDateTime(columndata.others.invoice_date) || '--' }}
                </div>
              </div>
              <div class="detail" *ngIf="columndata.others && columndata.others.invoice_no">
                <div class="label">
                  {{ 'ORDER_VIEW.invoice_no' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ columndata.others.invoice_no || '--' }}
                </div>
              </div>
              <div class="detail" *ngIf="columndata.others && columndata.others.invoice_value">
                <div class="label">
                  {{ 'ORDER_VIEW.invoice_value' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ columndata.others.invoice_value || '--' }}
                </div>
              </div>
              <div class="detail" *ngIf="columndata.others && columndata.others.lr_date">
                <div class="label">
                  {{ 'ORDER_VIEW.docketdate' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ toShortDateTime(columndata.others.lr_date) || '--' }}
                </div>
              </div>
              <div class="detail" *ngIf="columndata.others && columndata.others.ps_date">
                <div class="label">
                  {{ 'ORDER_VIEW.packingslipdate' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ toShortDateTime(columndata.others.ps_date) || '--' }}
                </div>
              </div>
              <div class="detail" *ngIf="columndata.others && columndata.others.ps_num">
                <div class="label">
                  {{ 'ORDER_VIEW.packingslipnum' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ columndata.others.ps_num || '--' }}
                </div>
              </div>
              <div class="detail" *ngIf="columndata.others && columndata.others.cft_wt">
                <div class="label">
                  {{ 'ORDER_VIEW.cftweight' | translate}}
                </div>
                <div class="colon">
                  :
                </div>
                <div class="value">
                  {{ columndata.others.cft_wt || '--' }}
                </div>
              </div>
            </div>
  
          </div>
          <div>
            <div>
              <div class="bottom_table" *ngIf="columndata.box && columndata.box.length >0">
                <div class="header_box">
                  <div class="items"> {{'ORDER_VIEW.length' | translate}}</div>
                  <div class="items"> {{'ORDER_VIEW.breath' | translate}}</div>
                  <div class="items"> {{'ORDER_VIEW.height' | translate}}</div>
                  <div class="items"> {{'ORDER_VIEW.number_of_packages' | translate}}</div>
                  <div class="items"> {{'ORDER_VIEW.weight' | translate}}</div>
                </div>
                <div class="body_box" *ngFor="let item of columndata.box">
                  <div class="items">{{item.length}}</div>
                  <div class="items">{{item.breath}}</div>
                  <div class="items">{{item.height}}</div>
                  <div class="items">{{item.no_of_packages}}</div>
                  <div class="items">{{item.weight}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="body-section" [hidden]="tabIndex!=1">
  
          <div class="container-fluid">
            <br /><br />
            <ul class="list-unstyled multi-steps">
              <li [ngClass]="{'is-active': awb_status === 'Order Booked'}">
                <div>
                  <div>Ordered</div>
                  <!-- <div class="subtext">Sunday</div> -->
                  <div class="subtext">{{time_line['Ordered'] ? getIndianDate(time_line['Ordered'].split(',')[0]) : ''}}
                  </div>
                </div>
              </li>
              <li [ngClass]="{'is-active': awb_status === 'In Transit'}">
                <div>
                  <div>In Transit</div>
                  <!-- <div class="subtext">Tuesday</div> -->
                  <div class="subtext">{{time_line['In Transit'] ? getIndianDate(time_line['In Transit'].split(',')[0]) :
                    ''}}</div>
                </div>
              </li>
              <!-- <li  [ngClass]="{'is-active': awb_status === 'Arrived'}">
                <div>
                  <div>Arrived</div>
                  <div class="subtext">wednesday</div>
                  <div class="subtext">09-07-2022</div>
                </div>
              </li> -->
              <li [ngClass]="{'is-active': awb_status === 'Out For Delivery'}">
                <div>
                  <div>Out For Delivery</div>
                  <!-- <div class="subtext">wednesday</div> -->
                  <div class="subtext">
                    {{time_line['Out For Delivery'] ? getIndianDate(time_line ['Out For Delivery'].split(',')[0]) : ''}} </div>
                </div>
              </li>
              <li [ngClass]="{'is-active': awb_status === 'Delivered'}">
                <div>
                  <div>Delivered</div>
                  <!-- <div class="subtext">wednesday</div> -->
                  <div class="subtext">{{time_line['Delivered'] ? getIndianDate(time_line['Delivered'].split(',')[0]) :
                    ''}}</div>
                </div>
              </li>
            </ul>
            <ng-template #noTrails>
              <div class="noOrders" style="padding-top: 30px;">
                {{'ORDER_VIEW.no_trails' | translate}}
              </div>
            </ng-template>
  
          </div>
          <div class="table">
            <table mat-table [dataSource]="trails_array" class="mat-elevation-z8">
  
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.status}} </td>
              </ng-container>
  
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let element">{{ toShortDateTime(element.date)}} </td>
              </ng-container>
  
              <ng-container matColumnDef="comments">
                <th mat-header-cell *matHeaderCellDef> Recent Updates </th>
                <td mat-cell *matCellDef="let element" style="width: 350px;"> {{element.comments}} </td>
              </ng-container>
  
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>
  
      </div>
    </div>